var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPackage3NuLarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 90,
    viewBox: "0 0 196 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h196v90H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.81 24.13h26.923v52.716H70.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.612 14.848h22.439v61.998H86.612zM114.377 33.769h21.352v43.077h-21.352zM43.653 40.202H67.96v36.644H43.653z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.406 26.596h17.75v50.25h-17.75zM39.005 35.818h13.089v41.03H39.005zM138.596 44.126h16.625v32.72h-16.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.405 53.039H165.5v23.807h-12.095zM30.5 53.039h12.095v23.807H30.5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M57.324 52.827h81.351v23.986h-81.35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9C4B9",
    d: "M56.623 74.01h82.752v2.794H56.623z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M138.632 48.47H57.368L55.92 52.92h84.156zM113.676 55.447h3.787v6.658h-3.787z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M117.46 62.107h-3.782l-.221 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(113.457 55.447)"
  }), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M118.943 55.447h3.787v6.658h-3.787z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M122.727 62.107h-3.782l-.218 1.65h4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 6.655H.216V5.07L4.003 1.4z",
    transform: "translate(118.727 55.447)"
  })), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M125.915 55.447h3.787v6.658h-3.787z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M129.697 62.107h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(125.696 55.447)"
  }), /*#__PURE__*/React.createElement("g", null, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M131.182 55.447h3.787v6.658h-3.787z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M134.964 62.107h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(130.963 55.447)"
  }))), /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M113.676 64.864h3.787v6.658h-3.787z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M117.46 71.526h-3.782l-.221 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(113.457 64.864)"
  }), /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M118.943 64.864h3.787v6.658h-3.787z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M122.727 71.526h-3.782l-.218 1.65h4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 6.655H.216V5.07L4.003 1.4z",
    transform: "translate(118.727 64.864)"
  })), /*#__PURE__*/React.createElement("g", null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M125.915 64.864h3.787v6.658h-3.787z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M129.697 71.526h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(125.696 64.864)"
  }), /*#__PURE__*/React.createElement("g", null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M131.182 64.864h3.787v6.658h-3.787z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M134.964 71.526h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(130.963 64.864)"
  })))), /*#__PURE__*/React.createElement("g", null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M61.03 55.447h3.788v6.658H61.03z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M64.816 62.107h-3.782l-.22 1.65h4.223z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.216V5.07L4.006 1.4z",
    transform: "translate(60.815 55.447)"
  }), /*#__PURE__*/React.createElement("g", null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M66.298 55.447h3.787v6.658h-3.787z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M70.083 62.107h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.216V5.07L4.006 1.4z",
    transform: "translate(66.082 55.447)"
  })), /*#__PURE__*/React.createElement("g", null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M73.27 55.447h3.788v6.658H73.27z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M77.055 62.107H73.27l-.218 1.65h4.221z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(73.052 55.447)"
  }), /*#__PURE__*/React.createElement("g", null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M78.538 55.447h3.787v6.658h-3.787z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M82.322 62.107h-3.784l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(78.319 55.447)"
  }))), /*#__PURE__*/React.createElement("g", null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M61.03 64.864h3.788v6.658H61.03z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M64.816 71.526h-3.782l-.22 1.65h4.223z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.216V5.07L4.006 1.4z",
    transform: "translate(60.815 64.864)"
  }), /*#__PURE__*/React.createElement("g", null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M66.298 64.864h3.787v6.658h-3.787z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M70.083 71.526h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.216V5.07L4.006 1.4z",
    transform: "translate(66.082 64.864)"
  })), /*#__PURE__*/React.createElement("g", null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M73.27 64.864h3.788v6.658H73.27z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M77.055 71.526H73.27l-.218 1.65h4.221z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(73.052 64.864)"
  }), /*#__PURE__*/React.createElement("g", null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M78.538 64.864h3.787v6.658h-3.787z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M82.322 71.526h-3.784l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(78.319 64.864)"
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C5",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.403 4.455h81.351v1.65H1.403z",
    transform: "translate(55.921 48.47)"
  }), /*#__PURE__*/React.createElement("g", null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "m82.666 45.578 15.333-12.547 15.333 12.547z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M110.623 76.834H85.377v-31.26L98 35.194l12.624 10.38z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M88.883 62.856h18.233v13.98H88.883z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M6.217 29.965v13.838h.841V30.46h16.55v13.343h.843V29.965z",
    transform: "translate(82.666 33.03)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M84.675 60.88h26.649v2.116H84.675z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M103.068 69.044c-.098-1.99-2.328-3.578-5.07-3.578-2.74 0-4.97 1.59-5.068 3.578l-.005 7.78h10.148l-.005-7.78z",
    fill: "#9A5238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.076 11.358h5.071l-.004-7.78C10.045 1.59 7.815 0 5.076 0v11.358z",
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(92.925 65.466)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M100.806 42.86A2.813 2.813 0 0 1 98 45.681a2.813 2.813 0 0 1-2.804-2.82A2.813 2.813 0 0 1 98 40.038a2.813 2.813 0 0 1 2.805 2.821z",
    fill: "#BD8F7E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M100.211 42.86a2.216 2.216 0 0 1-2.21 2.223 2.216 2.216 0 0 1-2.21-2.223c0-1.228.989-2.223 2.21-2.223s2.21.995 2.21 2.223z",
    fill: "#F9DFD1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M88.202 48.686h3.787v9.197h-3.787z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M91.986 57.887h-3.782l-.218 1.65h4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 9.195H.216V7.609l3.787-3.67z",
    transform: "translate(87.986 48.686)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M93.47 48.686h3.786v9.197H93.47z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M97.254 57.887h-3.782l-.219 1.65h4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 9.195H.216V7.609l3.787-3.67z",
    transform: "translate(93.253 48.686)"
  }), /*#__PURE__*/React.createElement("g", null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M98.737 48.686h3.787v9.197h-3.787z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M102.521 57.887H98.74l-.218 1.65h4.219z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 9.195H.216V7.609l3.787-3.67z",
    transform: "translate(98.52 48.686)"
  })), /*#__PURE__*/React.createElement("g", null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M104.004 48.686h3.787v9.197h-3.787z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M107.789 57.887h-3.782l-.219 1.65h4.22z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M104.011 49.866h3.785l.218-1.65h-4.221zM98.744 49.866h3.784l.219-1.65h-4.222zM93.476 49.866h3.785l.218-1.65h-4.221zM88.21 49.866h3.783l.219-1.65H87.99z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M19.8 9.665h-3.786V8.079l3.787-3.67z",
    transform: "translate(87.99 48.216)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.713 13.361 15.333 2.98l12.62 10.384.004-.831L15.333 2.15 2.71 12.532z",
    transform: "translate(82.666 33.03)"
  }), /*#__PURE__*/React.createElement("g", null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M106.788 72.924h4.208v3.91h-4.208zM106.802 63.012h4.208v3.263h-4.208z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h4.208v3.263H0z",
    transform: "translate(106.802 63.012)"
  }), /*#__PURE__*/React.createElement("g", null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M84.99 72.924h4.208v3.91H84.99zM85.004 63.012h4.208v3.263h-4.208z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h4.208v3.263H0z",
    transform: "translate(85.004 63.012)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M78.37 29.605h1.64v47.243h-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.965 34.303c-2.857 1.957-5.716-1.958-8.573 0V29.41c2.857-1.958 5.716 1.957 8.573 0v4.893z",
    fill: "#F6C760"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48.426 71.285-.41-.185c-.242.538-.94 1.776-1.737 2.225-.22.087-.287-.165-.3-.353v-2.095h-.81v2.109c-.015.197-.093.449-.34.316-.78-.47-1.459-1.67-1.696-2.202l-.41.185c.041.092.882 1.95 2.064 2.508.264.135.353.538.383.82v2.235h.809V74.63c.027-.286.116-.703.39-.836h-.01c1.183-.555 2.023-2.413 2.064-2.507l.003-.003z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.854 68.06a2.302 2.302 0 0 0-2.276-2.624h-.039a2.296 2.296 0 0 0-1.966-1.113c-.834 0-1.563.447-1.966 1.114h-.039a2.302 2.302 0 0 0-2.276 2.624 2.315 2.315 0 0 0-.654 1.613 2.302 2.302 0 0 0 2.297 2.31c.679 0 1.29-.295 1.71-.767a2.273 2.273 0 0 0 1.855 0c.422.472 1.03.767 1.711.767a2.302 2.302 0 0 0 2.297-2.31c0-.628-.248-1.196-.654-1.613z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.211 71.533c-.679 0-1.29-.298-1.71-.768a2.273 2.273 0 0 1-1.855 0 2.283 2.283 0 0 1-1.711.768 2.3 2.3 0 0 1-2.285-2.086 2.302 2.302 0 0 0 2.285 2.537c.679 0 1.29-.295 1.71-.767a2.273 2.273 0 0 0 1.855 0c.422.472 1.03.767 1.711.767a2.302 2.302 0 0 0 2.286-2.537 2.301 2.301 0 0 1-2.286 2.086z",
    fill: "#528C10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m145.775 68.874-.543-.245c-.319.715-1.244 2.354-2.298 2.95-.294.114-.38-.22-.4-.468v-2.778h-1.07v2.794c-.023.261-.125.596-.453.417-1.035-.62-1.932-2.216-2.244-2.917l-.543.245c.055.122 1.17 2.585 2.737 3.32.35.182.467.714.505 1.087v3.562h1.071v-3.539c.037-.378.153-.933.517-1.11h-.011c1.567-.735 2.681-3.198 2.736-3.32l-.004.002z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.668 64.602a3.052 3.052 0 0 0-3.014-3.477h-.053a3.034 3.034 0 0 0-5.208 0h-.052a3.052 3.052 0 0 0-3.014 3.477 3.062 3.062 0 0 0-.866 2.139 3.052 3.052 0 0 0 3.044 3.062c.9 0 1.708-.395 2.266-1.018a3.01 3.01 0 0 0 2.456 0 3.028 3.028 0 0 0 2.267 1.018 3.052 3.052 0 0 0 3.044-3.062c0-.832-.33-1.586-.866-2.139h-.004z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49 69.204c-.9 0-1.709-.394-2.267-1.017a3.01 3.01 0 0 1-2.456 0 3.028 3.028 0 0 1-2.267 1.017 3.049 3.049 0 0 1-3.028-2.764 3.052 3.052 0 0 0 3.03 3.362c.9 0 1.709-.394 2.267-1.017a3.01 3.01 0 0 0 2.456 0 3.028 3.028 0 0 0 2.267 1.018 3.052 3.052 0 0 0 3.03-3.363 3.052 3.052 0 0 1-3.028 2.764h-.004z",
    fill: "#528C10"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57.646 68.003-.606-.272c-.356.797-1.385 2.624-2.563 3.288-.328.129-.426-.245-.445-.52v-3.094H52.84v3.115c-.025.29-.14.662-.506.465-1.153-.692-2.153-2.468-2.502-3.252l-.606.273c.062.137 1.301 2.883 3.049 3.701.391.202.521.795.565 1.212v3.929h1.193v-3.903c.041-.422.171-1.039.577-1.238h-.012c1.748-.82 2.99-3.566 3.049-3.704z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.756 63.241c.02-.151.031-.305.031-.463 0-1.884-1.52-3.412-3.392-3.412h-.057a3.383 3.383 0 0 0-5.805 0h-.057c-1.873 0-3.392 1.528-3.392 3.412 0 .156.011.312.032.463a3.41 3.41 0 0 0-.966 2.384c0 1.883 1.52 3.412 3.392 3.412a3.378 3.378 0 0 0 2.527-1.134 3.372 3.372 0 0 0 2.738 0 3.375 3.375 0 0 0 2.527 1.134c1.872 0 3.392-1.529 3.392-3.412 0-.929-.369-1.767-.966-2.384h-.004z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.33 68.368a3.378 3.378 0 0 1-2.527-1.135 3.372 3.372 0 0 1-2.739 0 3.375 3.375 0 0 1-2.527 1.135 3.402 3.402 0 0 1-3.376-3.08c-.011.11-.016.222-.016.334 0 1.884 1.52 3.413 3.392 3.413a3.378 3.378 0 0 0 2.527-1.135 3.372 3.372 0 0 0 2.739 0 3.375 3.375 0 0 0 2.526 1.135c1.873 0 3.393-1.529 3.393-3.413 0-.112-.005-.224-.016-.334a3.402 3.402 0 0 1-3.377 3.08z",
    fill: "#528C10"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPackage3NuLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/package-3nu-large.8838210f65b5f9e8353ff1b144737540.svg";